import React from "react";
import { Card, Typography } from "antd";
import { DocumentTitle } from "../../components";
import I18n from "../../i18n";

export default function Contact() {
  return (
    <DocumentTitle title={I18n.general.contactUs}>
      <Card
        style={{ margin: 32 }}
        title={
          <Typography.Title level={3}>
            {I18n.general.contactUs}
          </Typography.Title>
        }
      >
        <Typography.Paragraph>
          در صورتی که با مشکلی در سایت بهارا برند روبرو شدید یا سوالی داشتید از
          طریق راه‌های زیر با ما در ارتباط باشید.
        </Typography.Paragraph>
        <Typography.Paragraph>
          پشتیبانی تلفنی بهارا‌ برند: 09055212520
        </Typography.Paragraph>
        <Typography.Paragraph>پشتیبانی واتسپ: 09055212520</Typography.Paragraph>
        <Typography.Paragraph>
          پشتیبانی تلگرام: 09055212520
        </Typography.Paragraph>
      </Card>
    </DocumentTitle>
  );
}
